import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryStrip() {
  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-18">
      <div className="flex items-end justify-between gap-4 mb-8">
        <div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">按类型探索角色</h2>
          <p className="mt-2 text-sm text-foreground-600">六大妖精分类，快速定位你感兴趣的角色方向</p>
        </div>
        <Link to="/characters" className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-700 hover:text-primary-600 whitespace-nowrap">
          全部角色
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
        {categories.map((cat) => (
          <Link
            key={cat.id}
            to={`/characters?c=${cat.id}`}
            className="group flex flex-col items-center rounded-xl border border-background-200/70 bg-background-100 p-4 text-center transition-colors hover:border-primary-300 hover:bg-background-50"
          >
            <span className="relative mb-3 flex h-14 w-14 items-center justify-center overflow-hidden rounded-full bg-primary-500/10 text-primary-700">
              <img src={cat.image} alt={cat.name} className="absolute inset-0 h-full w-full object-cover opacity-30" loading="lazy" />
              <i className={`relative ${cat.icon} text-xl`} />
            </span>
            <span className="text-sm font-medium text-foreground-900">{cat.name}</span>
            <span className="mt-0.5 text-xs text-foreground-500">{cat.count} 位角色</span>
          </Link>
        ))}
      </div>
    </section>
  );
}